module.exports = __webpack_public_path__ + "static/media/Doc3.f1addb42.jpg";